const M = "/assets/robbed/mascots";

// APPROVED individual ROBBED mascot layers — one complete character per asset.
// Used by the Meme Generator (ROBBED MASCOTS category) and across the site.
export const ROBBED_MASCOTS = [
  { id: "pointing", label: "Pointing", src: `${M}/pointing.png` },
  { id: "shrug", label: "Shrug", src: `${M}/shrug.png` },
  { id: "chart", label: "Red Chart", src: `${M}/chart.png` },
  { id: "moneybag", label: "Money Bag", src: `${M}/moneybag.png` },
  { id: "crate", label: "On The Crate", src: `${M}/crate.png` },
  { id: "jump", label: "Victory Jump", src: `${M}/jump.png` },
  { id: "stare", label: "Crossed Arms", src: `${M}/stare.png` },
  { id: "throne", label: "The Throne", src: `${M}/throne.png` },
  { id: "crying", label: "Crying", src: `${M}/crying.png` },
];

export const ASSETS = {
  circleLogo: "/assets/robbed/logos/circle-logo.png",
  emblem: "/assets/robbed/logos/full-emblem.png",
  certified: "/assets/robbed/badges/certified.png",
  // Site-wide mascot poses use the approved clean individual assets.
  pointing: `${M}/pointing.png`,
  shrugging: `${M}/shrug.png`,
  crying: `${M}/crying.png`,
  // Dedicated page-specific artwork (do NOT reuse elsewhere).
  leaderboardHero: "/assets/mascot/leaderboard-mascot.png",
};
